import {useQuery} from '@apollo/react-hooks';

import type {GetCsmInfo as GetCsmInfoQuery} from 'nutshell-graphql-types';

import GET_CSM_INFO from './graphql/queries/get-csm-info.graphql';

export const useGetCsmInfo = () => {
    const {data} = useQuery<GetCsmInfoQuery, Record<any, any>>(GET_CSM_INFO, {
        fetchPolicy: 'cache-and-network',
    });

    const csmInfo = data ? data.csmInfo : null;

    return {
        csmInfo,
    };
};
